/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getSalesStatsFilterOptions } from '../fn/sales-stats/get-sales-stats-filter-options';
import { GetSalesStatsFilterOptions$Params } from '../fn/sales-stats/get-sales-stats-filter-options';
import { getSalesStatsMonthlyShipped } from '../fn/sales-stats/get-sales-stats-monthly-shipped';
import { GetSalesStatsMonthlyShipped$Params } from '../fn/sales-stats/get-sales-stats-monthly-shipped';
import { getSalesStatsShippedByCustomer } from '../fn/sales-stats/get-sales-stats-shipped-by-customer';
import { GetSalesStatsShippedByCustomer$Params } from '../fn/sales-stats/get-sales-stats-shipped-by-customer';
import { getSalesStatsShippedByLine } from '../fn/sales-stats/get-sales-stats-shipped-by-line';
import { GetSalesStatsShippedByLine$Params } from '../fn/sales-stats/get-sales-stats-shipped-by-line';
import { getSalesStatsShippedDetail } from '../fn/sales-stats/get-sales-stats-shipped-detail';
import { GetSalesStatsShippedDetail$Params } from '../fn/sales-stats/get-sales-stats-shipped-detail';
import { getSalesStatsShippedQuantityByLine } from '../fn/sales-stats/get-sales-stats-shipped-quantity-by-line';
import { GetSalesStatsShippedQuantityByLine$Params } from '../fn/sales-stats/get-sales-stats-shipped-quantity-by-line';
import { getSalesStatsSummary } from '../fn/sales-stats/get-sales-stats-summary';
import { GetSalesStatsSummary$Params } from '../fn/sales-stats/get-sales-stats-summary';
import { getSalesStatsSyncStatus } from '../fn/sales-stats/get-sales-stats-sync-status';
import { GetSalesStatsSyncStatus$Params } from '../fn/sales-stats/get-sales-stats-sync-status';
import { SalesStatsFilterOptionsResponse } from '../models/sales-stats-filter-options-response';
import { SalesStatsMonthlyShippedResponse } from '../models/sales-stats-monthly-shipped-response';
import { SalesStatsShippedByCustomerResponse } from '../models/sales-stats-shipped-by-customer-response';
import { SalesStatsShippedByLineResponse } from '../models/sales-stats-shipped-by-line-response';
import { SalesStatsShippedDetailResponse } from '../models/sales-stats-shipped-detail-response';
import { SalesStatsShippedQuantityByLineResponse } from '../models/sales-stats-shipped-quantity-by-line-response';
import { SalesStatsSummaryResponse } from '../models/sales-stats-summary-response';
import { SalesStatsSyncStatusResponse } from '../models/sales-stats-sync-status-response';

@Injectable({ providedIn: 'root' })
export class SalesStatsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSalesStatsFilterOptions()` */
  static readonly GetSalesStatsFilterOptionsPath = '/sales-stats/filter-options';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSalesStatsFilterOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesStatsFilterOptions$Response(params: GetSalesStatsFilterOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesStatsFilterOptionsResponse>> {
    return getSalesStatsFilterOptions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSalesStatsFilterOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesStatsFilterOptions(params: GetSalesStatsFilterOptions$Params, context?: HttpContext): Observable<SalesStatsFilterOptionsResponse> {
    return this.getSalesStatsFilterOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<SalesStatsFilterOptionsResponse>): SalesStatsFilterOptionsResponse => r.body)
    );
  }

  /** Path part for operation `getSalesStatsMonthlyShipped()` */
  static readonly GetSalesStatsMonthlyShippedPath = '/sales-stats/monthly-shipped';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSalesStatsMonthlyShipped()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesStatsMonthlyShipped$Response(params: GetSalesStatsMonthlyShipped$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesStatsMonthlyShippedResponse>> {
    return getSalesStatsMonthlyShipped(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSalesStatsMonthlyShipped$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesStatsMonthlyShipped(params: GetSalesStatsMonthlyShipped$Params, context?: HttpContext): Observable<SalesStatsMonthlyShippedResponse> {
    return this.getSalesStatsMonthlyShipped$Response(params, context).pipe(
      map((r: StrictHttpResponse<SalesStatsMonthlyShippedResponse>): SalesStatsMonthlyShippedResponse => r.body)
    );
  }

  /** Path part for operation `getSalesStatsShippedByCustomer()` */
  static readonly GetSalesStatsShippedByCustomerPath = '/sales-stats/shipped-by-customer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSalesStatsShippedByCustomer()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesStatsShippedByCustomer$Response(params: GetSalesStatsShippedByCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesStatsShippedByCustomerResponse>> {
    return getSalesStatsShippedByCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSalesStatsShippedByCustomer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesStatsShippedByCustomer(params: GetSalesStatsShippedByCustomer$Params, context?: HttpContext): Observable<SalesStatsShippedByCustomerResponse> {
    return this.getSalesStatsShippedByCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<SalesStatsShippedByCustomerResponse>): SalesStatsShippedByCustomerResponse => r.body)
    );
  }

  /** Path part for operation `getSalesStatsShippedByLine()` */
  static readonly GetSalesStatsShippedByLinePath = '/sales-stats/shipped-by-line';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSalesStatsShippedByLine()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesStatsShippedByLine$Response(params: GetSalesStatsShippedByLine$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesStatsShippedByLineResponse>> {
    return getSalesStatsShippedByLine(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSalesStatsShippedByLine$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesStatsShippedByLine(params: GetSalesStatsShippedByLine$Params, context?: HttpContext): Observable<SalesStatsShippedByLineResponse> {
    return this.getSalesStatsShippedByLine$Response(params, context).pipe(
      map((r: StrictHttpResponse<SalesStatsShippedByLineResponse>): SalesStatsShippedByLineResponse => r.body)
    );
  }

  /** Path part for operation `getSalesStatsShippedDetail()` */
  static readonly GetSalesStatsShippedDetailPath = '/sales-stats/shipped-detail';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSalesStatsShippedDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesStatsShippedDetail$Response(params: GetSalesStatsShippedDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesStatsShippedDetailResponse>> {
    return getSalesStatsShippedDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSalesStatsShippedDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesStatsShippedDetail(params: GetSalesStatsShippedDetail$Params, context?: HttpContext): Observable<SalesStatsShippedDetailResponse> {
    return this.getSalesStatsShippedDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<SalesStatsShippedDetailResponse>): SalesStatsShippedDetailResponse => r.body)
    );
  }

  /** Path part for operation `getSalesStatsShippedQuantityByLine()` */
  static readonly GetSalesStatsShippedQuantityByLinePath = '/sales-stats/shipped-quantity-by-line';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSalesStatsShippedQuantityByLine()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesStatsShippedQuantityByLine$Response(params: GetSalesStatsShippedQuantityByLine$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesStatsShippedQuantityByLineResponse>> {
    return getSalesStatsShippedQuantityByLine(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSalesStatsShippedQuantityByLine$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesStatsShippedQuantityByLine(params: GetSalesStatsShippedQuantityByLine$Params, context?: HttpContext): Observable<SalesStatsShippedQuantityByLineResponse> {
    return this.getSalesStatsShippedQuantityByLine$Response(params, context).pipe(
      map((r: StrictHttpResponse<SalesStatsShippedQuantityByLineResponse>): SalesStatsShippedQuantityByLineResponse => r.body)
    );
  }

  /** Path part for operation `getSalesStatsSummary()` */
  static readonly GetSalesStatsSummaryPath = '/sales-stats/summary';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSalesStatsSummary()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesStatsSummary$Response(params: GetSalesStatsSummary$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesStatsSummaryResponse>> {
    return getSalesStatsSummary(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSalesStatsSummary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesStatsSummary(params: GetSalesStatsSummary$Params, context?: HttpContext): Observable<SalesStatsSummaryResponse> {
    return this.getSalesStatsSummary$Response(params, context).pipe(
      map((r: StrictHttpResponse<SalesStatsSummaryResponse>): SalesStatsSummaryResponse => r.body)
    );
  }

  /** Path part for operation `getSalesStatsSyncStatus()` */
  static readonly GetSalesStatsSyncStatusPath = '/sales-stats/sync-status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSalesStatsSyncStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesStatsSyncStatus$Response(params?: GetSalesStatsSyncStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesStatsSyncStatusResponse>> {
    return getSalesStatsSyncStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSalesStatsSyncStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesStatsSyncStatus(params?: GetSalesStatsSyncStatus$Params, context?: HttpContext): Observable<SalesStatsSyncStatusResponse> {
    return this.getSalesStatsSyncStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<SalesStatsSyncStatusResponse>): SalesStatsSyncStatusResponse => r.body)
    );
  }

}
